import type { CSSProperties } from 'react'

const TONE_CLASS = {
  positive: 'chip-pos',
  warning: 'chip-warn',
  negative: 'chip-neg',
} as const

const TONE_TEXT = {
  positive: 'var(--positive)',
  warning: 'var(--warning)',
  negative: 'var(--negative)',
} as const

/**
 * `filled` opts into the background treatment tokens.css already defines. Text-only
 * tinting is too faint for a status that has to be noticed at a glance, and the palette
 * is deliberately muted — so contrast comes from the existing filled classes rather than
 * from a louder colour.
 */
export function Chip({
  label,
  color,
  filled = false,
  className: extraClassName,
  style,
}: {
  readonly label: string
  readonly color?: 'positive' | 'negative' | 'warning'
  readonly filled?: boolean
  readonly className?: string
  readonly style?: CSSProperties
}) {
  const className = [
    color !== undefined && filled ? `chip ${TONE_CLASS[color]}` : 'chip',
    extraClassName ?? '',
  ]
    .filter((c) => c !== '')
    .join(' ')
  const tint = color !== undefined && !filled ? { color: TONE_TEXT[color] } : {}
  return (
    <span className={className} style={{ ...tint, ...style }}>
      {label}
    </span>
  )
}
